require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-reminder-to-all-current-visa-credit-card-holders.json") })
        }
      }, "path---es-articles-reminder-to-all-current-visa-credit-card-holders");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-reminder-to-all-current-visa-credit-card-holders!./.cache/json/es-articles-reminder-to-all-current-visa-credit-card-holders.json
// module id = 2235
// module chunks = 231608221292675